import Home from './home';
import Civilite from './civilite';
import Genre from './genre';
import Langue from './langue';
import ModeReglement from './mode-reglement';
import ConditionReglement from './condition-reglement';
import CentreCout from './centre-cout';
import LigneBudgetaire from './ligne-budgetaire';
import Devise from './devise';
import Priorite from './priorite';
import Entrepot from './entrepot';
import Famille from './famille';
import Unite from './unite';
import CleParam from './cle-param';
import TypeEvenement from './type-evenement';

import Direction from './direction';
import EmployeService from './employe-service';

import CcnStatutCategorie from './ccn-statut-categorie';
import ContratType from './contrat-type';
import ConventionCollective from './convention-collective';
import EmploiNature from './emploi-nature';
import ExpressionTempsTravail from './expression-temps-travail';
import IrcStatutCategorie from './irc-statut-categorie';
import LienParente from './lien-parente';
import MotifEntree from './motif-entree';
import Profil from './profil';
import SalarieStatut from './salarie-statut';
import SituationAdministrative from './situation-administrative';
import SituationFamiliale from './situation-familiale';
import SpecificiteContrat from './specificite-contrat';

import NaturePoste from './nature-poste';
import Poste from './poste';
import StatutCandidature from './statut-candidature';

import DomaineCompetence from './domaine-competence';
import Competence from './competence';
import Habilitation from './habilitation';
import EntretienType from './entretien-type';

import EmployeSociete from './employe-societe';
import TypeFichierAdmin from './type-fichier-admin';
import TypeEchange from './type-echange';
import TypeAbsence from './type-absence';
import Periodicite from './periodicite';
import TypeContratRemplacement from './type-contrat-remplacement';

export default [
  ...Home,
  ...Civilite,
  ...Genre,
  ...Langue,
  ...ModeReglement,
  ...ConditionReglement,
  ...CentreCout,
  ...LigneBudgetaire,
  ...Devise,
  ...Priorite,
  ...Entrepot,
  ...Famille,
  ...Unite,
  ...CleParam,
  ...TypeEvenement,

  ...Direction,
  ...EmployeService,

  ...Profil,
  ...CcnStatutCategorie,
  ...ContratType,
  ...ConventionCollective,
  ...EmploiNature,
  ...ExpressionTempsTravail,
  ...IrcStatutCategorie,
  ...LienParente,
  ...MotifEntree,

  ...SalarieStatut,
  ...SituationAdministrative,
  ...SituationFamiliale,
  ...SpecificiteContrat,

  ...NaturePoste,
  ...Poste,
  ...StatutCandidature,

  ...DomaineCompetence,
  ...Competence,
  ...Habilitation,
  ...EntretienType,
  ...EmployeSociete,
  ...TypeFichierAdmin,
  ...TypeAbsence,
  ...TypeEchange,
  ...Periodicite,
  ...TypeContratRemplacement,
];
